// extracted by mini-css-extract-plugin
export var active = "_2j-9";
export var backButton = "_2j-8";
export var clone = "_2j-e";
export var collapseBar = "_2j-k";
export var collapseMode = "_2j-m";
export var collapsed = "_2j-o";
export var dimmed = "_2j-i";
export var dragHandle = "_2j-c";
export var dropdownIcon = "_2j-g";
export var expanding = "_2j-n";
export var hidden = "_2j-x";
export var iconContainer = "_2j-q";
export var iconSwapper = "_2j-w";
export var navItem = "_2j-6";
export var navItemIcon = "_2j-f";
export var navProfile = "_2j-7";
export var notificationCountBadge = "_2j-j";
export var notificationDot = "_2j-r";
export var optionsContainer = "_2j-h";
export var primaryNav = "_2j-0";
export var primaryNavDivider = "_2j-v";
export var primaryNavResizeHandle = "_2j-2";
export var primaryNavResizing = "_2j-1";
export var primaryNavTabSection = "_2j-u";
export var primaryTab = "_2j-p";
export var primaryTabIconBox = "_2j-s";
export var secondaryNav = "_2j-3";
export var selected = "_2j-t";
export var settingsNav = "_2j-4";
export var settingsNavItems = "_2j-5";
export var show = "_2j-d";
export var sideNav = "_2j-l";
export var teamItem = "_2j-a";
export var userProfileItem = "_2j-b";